import CardCommon from '@op/components/CardCommon';
import React, { useState, useCallback } from 'react';
import VideoItem from './VideoItem';
import useIntls from '@opm/hooks/useIntls';
import { IVideoItemData } from '../../HashtagTable';

interface IVideoContent {
  videoList?: IVideoItemData[];
  hashtag?: string;
}

export default function VideoContent(props: IVideoContent) {
  const { intl } = useIntls();
  const { videoList, hashtag } = props;

  // 管理当前播放的视频 ID
  const [playingVideoId, setPlayingVideoId] = useState<string | null>(null);

  // 处理视频播放事件
  const handleVideoPlay = useCallback((videoId: string) => {
    setPlayingVideoId(videoId);
  }, []);

  return (
    <CardCommon
      title={intl('Video')}
      className='dbom-hashtag-video-player-content'
      contentCard
    >
      <div className='dbom-hashtag-video-list'>
        {videoList?.map((video, index) => (
          <VideoItem
            key={video.video_id + hashtag}
            videoId={video.video_id}
            videoImage={video.video_image}
            index={index}
            autoPlay={index === 0}
            videoInfo={video}
            isPlaying={playingVideoId === video.video_id}
            onPlay={handleVideoPlay}
          />
        ))}
      </div>
    </CardCommon>
  );
}